import { render } from "./Messages.vue?vue&type=template&id=568c85bf"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
script.render = render

export default script